module.exports = __webpack_public_path__ + "Checkmark.c3e6da82.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Checkmark.svg
// module id = 355
// module chunks = 0